import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';
import type { MoveItemsPayloadDTO } from '@/types/SixDetailDTOs';

export const moveItemsThunk = createAppAsyncThunk<
  undefined,
  { sixId: string } & MoveItemsPayloadDTO
>(
  'sixDetail/moveItems',
  withLoader(
    async({ sixId, ...payload }, { extra, dispatch }) => {
      await extra.sixDetailService.moveItems(sixId, payload);
      await dispatch(fetchSixDetailMetaAndFilesThunk(sixId)).unwrap();
      return undefined;
    }
  )
);
